(function () {
var $2d081a1fa49e40a2$exports = {};
/* Scroll & Nav Active Tracker */ const $2d081a1fa49e40a2$var$navEl = document.querySelector("nav");
const $2d081a1fa49e40a2$var$anchors = document.querySelectorAll("nav a:not([target=_blank])");
const $2d081a1fa49e40a2$var$anchoredElements = [
    ...$2d081a1fa49e40a2$var$anchors
].map((anchor)=>{
    const href = anchor.getAttribute("href");
    return href && href.startsWith("#") ? document.querySelector(href) : null;
}).filter(Boolean);
const $2d081a1fa49e40a2$var$elementToNavAnchor = new Map($2d081a1fa49e40a2$var$anchoredElements.map((element, index)=>[
        element,
        $2d081a1fa49e40a2$var$anchors[index]
    ]));
let $2d081a1fa49e40a2$var$oldScroll = window.scrollY;
function $2d081a1fa49e40a2$var$checkVisible(elm, threshold = 150) {
    const rect = elm.getBoundingClientRect();
    const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    const above = rect.bottom - threshold < 0;
    const below = rect.top - viewHeight + threshold >= 0;
    return !above && !below;
}
function $2d081a1fa49e40a2$var$updateNavSelection() {
    let activeSet = false;
    for (const anchoredElement of $2d081a1fa49e40a2$var$anchoredElements){
        if (!anchoredElement) continue;
        const visible = $2d081a1fa49e40a2$var$checkVisible(anchoredElement);
        const anchor = $2d081a1fa49e40a2$var$elementToNavAnchor.get(anchoredElement);
        if (anchor) {
            anchor.classList.toggle("active", !activeSet && visible);
            if (!activeSet && visible) activeSet = true;
        }
    }
}
window.addEventListener("scroll", ()=>{
    $2d081a1fa49e40a2$var$oldScroll = window.scrollY;
    $2d081a1fa49e40a2$var$updateNavSelection();
}, {
    passive: true
});
/* Mobile Menu Navigation */ const $2d081a1fa49e40a2$var$navButton = document.querySelector(".menu-toggle");
$2d081a1fa49e40a2$var$navButton?.addEventListener("click", ()=>{
    $2d081a1fa49e40a2$var$navButton.classList.toggle("open");
    $2d081a1fa49e40a2$var$navEl?.classList.toggle("open");
});
$2d081a1fa49e40a2$var$navEl?.addEventListener("click", (event)=>{
    if (!window.matchMedia("(max-width: 768px)").matches) return;
    if (event.target instanceof HTMLAnchorElement) {
        $2d081a1fa49e40a2$var$navButton?.classList.remove("open");
        $2d081a1fa49e40a2$var$navEl.classList.remove("open");
    }
});
/* Accordion Widget */ document.querySelectorAll("[data-role=expandable]").forEach((expandable)=>{
    const title = expandable.querySelector("[data-role=title]");
    const content = expandable.querySelector("[data-role=content]");
    // Ensure inner wrapper exists for CSS Grid transition
    if (content && !content.querySelector("[data-role=inner]")) {
        const inner = document.createElement("div");
        inner.setAttribute("data-role", "inner");
        while(content.firstChild)inner.appendChild(content.firstChild);
        content.appendChild(inner);
    }
    title?.setAttribute("role", "button");
    title?.setAttribute("tabindex", "0");
    const toggle = ()=>{
        const isExpanded = expandable.classList.toggle("expanded");
        title.setAttribute("aria-expanded", String(isExpanded));
    };
    title?.addEventListener("click", toggle);
    title?.addEventListener("keydown", (e)=>{
        const keyboardEvent = e;
        if (keyboardEvent.key === "Enter" || keyboardEvent.key === " ") {
            keyboardEvent.preventDefault();
            toggle();
        }
    });
});
/* Read More Widget */ document.querySelectorAll("[data-role=read_more]").forEach((expandable)=>{
    const buttonContainer = expandable.querySelector("[data-role=expand]");
    const parent = expandable.closest(".article-section");
    buttonContainer?.addEventListener("click", (event)=>{
        const target = expandable;
        const currentState = target.dataset.expandState;
        if (currentState === "open" && parent) parent.scrollIntoView({
            behavior: "smooth"
        });
        event.stopPropagation();
        event.preventDefault();
        target.dataset.expandState = currentState === "closed" ? "open" : "closed";
    });
});
/* Reference Dialog */ const $2d081a1fa49e40a2$var$dialog = document.querySelector("dialog.reference_dialog");
const $2d081a1fa49e40a2$var$openDialogBtn = document.querySelector("[data-role=open_dialog]");
const $2d081a1fa49e40a2$var$closeDialogBtn = document.querySelector("dialog .dialog-close");
$2d081a1fa49e40a2$var$openDialogBtn?.addEventListener("click", ()=>{
    $2d081a1fa49e40a2$var$dialog?.showModal();
});
$2d081a1fa49e40a2$var$closeDialogBtn?.addEventListener("click", ()=>{
    $2d081a1fa49e40a2$var$dialog?.close();
});
$2d081a1fa49e40a2$var$dialog?.addEventListener("click", (event)=>{
    if (event.target === $2d081a1fa49e40a2$var$dialog) $2d081a1fa49e40a2$var$dialog.close();
});

})();
//# sourceMappingURL=index.4f3927fd.js.map
